/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_ApprovedInputs */

const en_wb_operations_approved = /** @type {(inputs: Wb_Operations_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example flagged for the order owner. The order remains on hold until the address is confirmed.`)
};

const lv_wb_operations_approved = /** @type {(inputs: Wb_Operations_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs novirzīts pasūtījuma atbildīgajam. Pasūtījums paliek aizturēts, līdz adrese ir apstiprināta.`)
};

/**
* | output |
* | --- |
* | "Example flagged for the order owner. The order remains on hold until the address is confirmed." |
*
* @param {Wb_Operations_ApprovedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_approved = /** @type {((inputs?: Wb_Operations_ApprovedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_ApprovedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_approved(inputs)
	return en_wb_operations_approved(inputs)
});